// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"BaseNavigation_dropdownMenu__I2SV2"};